import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, IconButton, ListItemAvatar, ListItemText, ListItemSecondaryAction, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import {
	FilesExplorer,
	Icon,
	ImageAvatar,
	showDialogGenericInfo,
	SquareChip,
	Text,
	useSettings
} from 'app/main/components';

export default function DocumentsUsersListItem({ model, width }: ItemLayoutProps) {
	const dispatch = useDispatch();
	const { t, sysSettings } = useSettings();

	function handleOpen() {
		dispatch(
			showDialogGenericInfo({
				title: model.fold_title,
				content: (
					<FilesExplorer
						folderPath={`${sysSettings.docs_path}${model.fold_foldername}\\${model.user_title}`}
						disableUpload={!model.fold_personal}
						disableDelete={!model.fold_personal}
					/>
				),
				dialogProps: {
					fullWidth: true,
					maxWidth: 'lg'
				}
			})
		);
	}

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="users"
			uid={model.user_uid}
			avatar={model.user_avatar}
			initials={model.user_title_initials}
		/>
	);

	const button = (
		<ListItemSecondaryAction className="relative right-0 top-0 transform-none self-center">
			<Tooltip title={t('DOCUMENTS_VIEW_CONTENT')}>
				<IconButton className="h-48 w-48" onClick={handleOpen}>
					<Icon icon="folder" />
				</IconButton>
			</Tooltip>
		</ListItemSecondaryAction>
	);

	return (
		<GridListItem avatar={avatar} secondaryAction={button}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={{ xs: width >= 600 ? 6 : 12 }}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* TITLE */}
							<Text className="font-600" variant="subtitle2">
								{model.user_title}
							</Text>
						</Grid>
						{model.user_duties && (
							<Grid size={12}>
								{/* ROLES */}
								{model.user_duties.map((role, index) => (
									<SquareChip key={index} label={role.usdt_title} backgroundColor={role.usdt_color} />
								))}
							</Grid>
						)}
					</Grid>
				</Grid>
			</Grid>
		</GridListItem>
	);
}
